import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between py-2.5" }

import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";
import useSearch from "@/composables/use-search";
import WordHighlighter from "vue-word-highlighter";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItem',
  props: {
    text: {}
  },
  setup(__props: any) {



const { userInput } = useSearch();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(WordHighlighter), {
      "highlight-style": { fontWeight: 700, background: 'transparent', color: 'inherit' },
      query: _unref(userInput)
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.text), 1)
      ]),
      _: 1
    }, 8, ["query"]),
    _createVNode(SvgIcon, {
      "icon-name": "arrow-fat-right",
      class: "mt-1 h-3 w-3 shrink-0"
    })
  ]))
}
}

})